export const setRootProperty = (name: string, value: string | null) => document.documentElement.style.setProperty(name, value);

export const setRootVar = (name: string, value: string | null) => setRootProperty(`--${name}`, value);
